export const testimonials = [
  {
    name: 'Marcus Chen',
    handle: '@marcus_finds',
    avatar: 'MC',
    text: 'The Hipobuy Spreadsheet completely changed how I shop. Instead of spending hours scrolling through pages, I can find organized product lists with QC photos in minutes. The sneaker category alone saved me so much time.',
  },
  {
    name: 'Emily Rodriguez',
    handle: '@emily_shops',
    avatar: 'ER',
    text: 'I was skeptical at first, but the Hipobuy Spreadsheet resource hub is genuinely useful. The comparison guides helped me understand quality differences between sellers, and the category structure makes finding specific items super easy.',
  },
  {
    name: 'James Wilson',
    handle: '@jamesw_fashion',
    avatar: 'JW',
    text: 'As someone new to organized shopping, the Hipobuy Spreadsheet beginner guides were a lifesaver. The step-by-step tutorials and category breakdowns made the whole process feel approachable and straightforward.',
  },
  {
    name: 'Sophia Kim',
    handle: '@sophiak_style',
    avatar: 'SK',
    text: 'The Hipobuy Spreadsheet has become my go-to resource. The hoodie and jacket categories are incredibly well-organized, and the QC guides give me confidence before making any purchase decisions.',
  },
  {
    name: 'Daniel Park',
    handle: '@daniel_curates',
    avatar: 'DP',
    text: 'I have tried other spreadsheet resources before, but Hipobuy Spreadsheet stands out because of the detailed product research and community-driven quality checks. The fashion category is particularly well-curated with up-to-date finds.',
  },
  {
    name: 'Olivia Brooks',
    handle: '@olivia_luxe',
    avatar: 'OB',
    text: 'The Hipobuy Spreadsheet accessories and bags sections are incredible. I found pieces that I never would have discovered through regular searching. The comparison tables make it so easy to evaluate different options side by side.',
  },
];